<script lang="ts" setup>
import SkullIcon from "@/components/icon/SkullIcon.vue";
import { Mate, Visibility } from "@/types/entity";
import { computed } from "vue";
import { useAllVisibility } from "@/use/common";
import { useModule } from "@/stores/module";

const VISIBILITIES = useAllVisibility();
const props = defineProps<{
  mate: Mate;
}>();

const emit = defineEmits<{
  (e: "deleteMate"): void;
  (e: "update:mate", key: keyof Mate): void;
}>();

const disableDelete = computed(() => props.mate.isUser);

const moduleStore = useModule();

const clickVisibility = (visibility: Visibility) => {
  const { mate } = props;
  mate.visibility = visibility;
  emit("update:mate", "visibility");
};
</script>
<template>
  <div class="py-4 flex flex-col gap-4">
    <div class="flex flex-col gap-2 px-4">
      <div class="text-base-content/50">
        {{ $t("User.mate.visibility.visibility") }}
      </div>
      <div class="flex flex-col gap-2">
        <div
          v-for="item in VISIBILITIES"
          :key="item.value"
          :class="{ checked: mate.visibility === item.value }"
          class="radio-item"
          @click="clickVisibility(item.value)"
        >
          <label for="public">{{ $t(item.text) }}</label>
          <input
            :checked="mate.visibility === item.value"
            class="radio radio-xs"
            type="radio"
          />
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-2 px-4">
      <div class="text-error">
        {{ $t("User.mate.visibility.dangerZone") }}
      </div>
      <button
        :disabled="disableDelete"
        class="btn btn-error rounded btn-sm"
        @click="moduleStore.module?.deleteEntity"
      >
        <skull-icon class="w-4" />
        {{ $t("Buttons.deleteCharacter") }}
      </button>
    </div>
  </div>
</template>
<style scoped>
.radio-item {
  @apply flex justify-between items-center border p-2 rounded text-base-content/50;
}

.radio-item.checked {
  @apply border-base-content text-base-content;
}

.radio-item.checked .radio {
  @apply radio-primary;
}
</style>
